<template>
  <main :class="$style.view" v-if="page.fields">
    <ul :class="$style.list">
      <li
        v-for="(char, index) in sortedArtists"
        :key="`char-${index}`"
        :class="$style.chars"
      >
        <div :class="$style.char" v-html="char.char" />
        <ul :class="$style.artists">
          <li
            v-for="(artist, index) in char.artists"
            :key="`artist-${index}`"
            :class="$style.artist"
          >
            <div :class="$style.name">{{ artist.name }}</div>
            <ul :class="$style.images">
              <image-item
                v-for="(image, index) in artist.images"
                :key="`image-${index}`"
                :image="image"
                :title="artist.name"
                tag="li"
                :class="$style.image"
              />
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </main>
</template>

<script>
import PageService from '@/services/page'
import ImageItem from '@/components/image-item'

export default {
  components: {
    ImageItem
  },
  metaInfo() {
    return {
      title: this.page.fields ? this.page.fields.title : ''
    }
  },
  data() {
    return {
      page: {}
    }
  },
  computed: {
    sortedArtists() {
      let sorted = []

      this.page.children.forEach(child => {
        const char = child.fields.last_name.charAt(0).toUpperCase()
        const artist = child.fields.title
        const image = child.fields.work_images
        const artists = { name: artist, images: image }

        const charExists = sorted.some(obj => obj.char === char)
        if (!charExists) {
          const charObj = { char: char, artists: [artists] }
          sorted.push(charObj)
        } else {
          const existingChar = sorted.findIndex(obj => obj.char === char)
          sorted[existingChar].artists.push(artists)
        }
      })
      return sorted
    },
    firstChar() {
      let chars = []
      this.page.children.forEach(child => {
        const char = child.fields.last_name.charAt(0)

        const charExists = chars.includes(char)
        if (!charExists) {
          chars.push(char)
        } else {
          return
        }
      })
      return chars
    }
  },
  async created() {
    this.page = await PageService.get({ id: this.$route.name })
  }
}
</script>

<style lang="scss" module>
.view {
  @extend %view-padding;
}

.chars {
  display: flex;
  &:not(:last-of-type) {
    margin-bottom: calc(calc(var(--gutter) - 0.25em) * 2);
  }

  @media (min-width: $xxlarge) {
    &:not(:last-of-type) {
      margin-bottom: calc(calc(var(--gutter) - 0.25em) * 3);
    }
  }
}

.char {
  display: inline-block;
  padding-right: 5.5vw;
}

.artist {
  display: block;

  &:not(:last-of-type) {
    // -0.25em to remove gap introduced by inline-block
    margin-bottom: calc(calc(var(--gutter) - 0.25em) * 2);
  }

  @media (min-width: $xxlarge) {
    &:not(:last-of-type) {
      margin-bottom: calc(calc(var(--gutter) - 0.25em) * 3);
    }
  }
}

.name {
  display: block;
  width: 100%;
  padding-bottom: calc(var(--gutter) / 4);
}

.images {
  line-height: 0;
}

.image {
  height: 3.75em;
  display: inline-block;
  line-height: var(--lh-base); // Restore line-height from .images
  margin-bottom: calc(var(--gutter) / 2);

  img {
    height: 100%;
    width: auto;
  }

  // TODO: why is declaring gutter / 2 for padding necessary?
  &:not(:last-of-type) {
    padding-right: calc(var(--gutter) / 2);
  }

  @media (min-width: $large) {
    height: 3em;
  }
}
</style>
